window.onload = function() {
    if(document.querySelectorAll(".fluid-snapto").length > 0) {
        document.querySelectorAll(".fluid-snapto").forEach(function(i,e) {
            if(i.getAttribute("href") !== "") {
                let snapId = i.getAttribute("href");
                i.addEventListener("click", function(e) {
                    e.preventDefault();
                    let elemSnapId = document.querySelector(snapId);
                    elemSnapId.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
                })
            }
        })
    }
};
